/* MerryMantel: fade page sections in as they scroll into view.
   Styles are in assets/mm-theme.css. No-JS and reduced-motion visitors see everything at once. */
(function () {
  function init() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var items = Array.prototype.filter.call(main.children, function (el) {
      return el.classList.contains('shopify-section') && !/sticky|announcement/.test(el.id || '');
    });
    if (!items.length) return;
    document.documentElement.classList.add('mm-fade');
    var vh = window.innerHeight || 800;
    items.forEach(function (el, i) {
      el.classList.add('mm-fade-item');
      if (i === 0 || el.getBoundingClientRect().top < vh * 0.9) el.classList.add('mm-in');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('mm-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MerryMantel: swipe the product gallery on touch devices.
   The Elixir gallery (assets/shop-product-details.js) only binds thumbnail clicks and
   arrow clicks, so on a phone the main image cannot be changed by swiping. This adds a
   horizontal swipe on the main image and drives the theme's own changeImage(), so the
   thumbnails, the arrows and variant switching all stay in sync. Vertical scrolling is
   untouched: nothing calls preventDefault, and off-axis gestures are ignored. */
(function () {
  var MIN_DISTANCE = 40;   /* px of horizontal travel before it counts as a swipe */
  var MAX_OFF_AXIS = 0.8;  /* vertical travel must stay under this share of horizontal */
  var MAX_TIME = 800;      /* ms; a slower drag is not a swipe */

  function images() {
    return Array.prototype.slice.call(document.querySelectorAll('.shop-main-image'));
  }

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('active')) return i;
    }
    return 0;
  }

  function show(index) {
    var list = images();
    if (index < 0 || index > list.length - 1) return;
    if (typeof window.changeImage === 'function') {
      window.changeImage(index);
      return;
    }
    /* Fallback if the theme's gallery script did not run. */
    list.forEach(function (img, i) {
      img.classList.toggle('active', i === index);
      img.style.display = i === index ? 'block' : 'none';
    });
    var thumbs = document.querySelectorAll('.shop-thumbnail');
    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.classList.toggle('active', i === index);
    });
  }

  function bind() {
    var wrap = document.querySelector('.shop-main-image-wrapper');
    if (!wrap || wrap.getAttribute('data-mm-swipe') === '1') return;
    if (images().length < 2) return;
    wrap.setAttribute('data-mm-swipe', '1');

    var startX = 0, startY = 0, startedAt = 0, tracking = false;

    wrap.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startedAt = Date.now();
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      if (Date.now() - startedAt > MAX_TIME) return;
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < MIN_DISTANCE) return;
      if (Math.abs(dy) > Math.abs(dx) * MAX_OFF_AXIS) return;
      var list = images();
      show(dx < 0 ? activeIndex(list) + 1 : activeIndex(list) - 1);
    }, { passive: true });

    wrap.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
  }

  function start() {
    bind();
    /* The gallery markup can arrive late (theme editor, variant re-render). */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      bind();
      if (tries > 10) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', bind);
})();
